type StarBgProp = {
  className?: string;
  fill?: string;
};

const StarBg = ({ className, fill }: StarBgProp) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Vector">
      <path
        d="M28.9341 15.9622C28.9183 15.7421 28.7585 15.556 28.5436 15.5088C28.2422 15.4407 21.4675 13.8998 18.388 13.6247C18.202 10.3621 17.7145 4.89296 16.4723 1.7378C16.3963 1.54388 16.2102 1.4181 16.0031 1.4181C15.7961 1.4181 15.61 1.54388 15.534 1.7378C14.2891 4.89296 13.8043 10.3621 13.6182 13.6247C10.3711 13.9051 3.7536 15.4433 3.46007 15.5115C3.24517 15.5613 3.08791 15.7447 3.06956 15.9674C3.05384 16.1876 3.18227 16.392 3.38931 16.4732C6.57094 17.7285 10.6253 18.208 13.6182 18.3888C13.8043 21.6514 14.2918 27.1153 15.534 30.2678C15.61 30.4618 15.7961 30.5875 16.0031 30.5875C16.2102 30.5875 16.3963 30.4618 16.4723 30.2678C17.7145 27.1153 18.202 21.6514 18.388 18.3888C21.381 18.2106 25.4353 17.7285 28.617 16.4732C28.824 16.392 28.9524 16.185 28.9367 15.9648L28.9341 15.9622ZM17.4026 14.1199C17.4157 14.3794 17.6228 14.5838 17.8822 14.5995C19.7823 14.6965 24.104 15.5796 26.5492 16.1037C23.6506 16.9423 20.3379 17.2751 17.8822 17.4009C17.6228 17.414 17.4183 17.621 17.4026 17.8805C17.2637 20.5796 16.9021 25.2102 16.0005 28.4623C15.099 25.2075 14.7399 20.577 14.5984 17.8805C14.5853 17.621 14.3782 17.4166 14.1188 17.4009C11.6605 17.2725 8.33735 16.9397 5.43876 16.0985C7.83416 15.577 12.0667 14.7043 14.1188 14.5969C14.3782 14.5838 14.5827 14.3768 14.5984 14.1173C14.7373 11.4181 15.099 6.79024 16.0005 3.5355C17.0776 6.7221 17.4026 14.1173 17.4026 14.1173V14.1199Z"
        fill={fill}
      />
      <path
        d="M26.383 12.0813C26.4485 12.0813 26.5167 12.0682 26.5796 12.0393L31.5643 9.91658C31.8211 9.80651 31.9417 9.51036 31.8316 9.25353C31.7216 8.9967 31.4254 8.87616 31.1686 8.98623L26.1838 11.109C25.927 11.2191 25.8064 11.5152 25.9165 11.772C25.9977 11.9634 26.1838 12.0787 26.3804 12.0787L26.383 12.0813Z"
        fill={fill}
      />
      <path
        d="M5.42067 19.9585L0.435942 22.0813C0.179106 22.1913 0.0585608 22.4875 0.168634 22.7443C0.249878 22.9356 0.435942 23.0509 0.632501 23.0509C0.698021 23.0509 0.766161 23.0378 0.82906 23.009L5.81379 20.8862C6.07063 20.7761 6.19119 20.48 6.08112 20.2232C5.97104 19.9664 5.67489 19.8458 5.41805 19.9559L5.42067 19.9585Z"
        fill={fill}
      />
      <path
        d="M11.1125 5.81513C11.1938 6.00643 11.3798 6.12175 11.5764 6.12175C11.6419 6.12175 11.71 6.10864 11.7729 6.07981C12.0298 5.96975 12.1503 5.67363 12.0403 5.41682L9.91745 0.432508C9.80737 0.175693 9.51122 0.0551426 9.25438 0.165206C8.99755 0.27527 8.87698 0.5714 8.98706 0.828215L11.1099 5.81251L11.1125 5.81513Z"
        fill={fill}
      />
      <path
        d="M20.8893 26.1823C20.7793 25.9255 20.4831 25.8049 20.2263 25.915C19.9694 26.025 19.8489 26.3212 19.959 26.578L22.0818 31.5623C22.163 31.7536 22.3491 31.8689 22.5457 31.8689C22.6112 31.8689 22.6793 31.8558 22.7422 31.827C22.9991 31.7169 23.1196 31.4208 23.0095 31.164L20.8867 26.1797L20.8893 26.1823Z"
        fill={fill}
      />
      <path
        d="M20.0253 5.99873C20.0882 6.02232 20.1511 6.03543 20.214 6.03543C20.4132 6.03543 20.6045 5.91487 20.6831 5.71833L22.7064 0.694726C22.8112 0.435291 22.6854 0.141786 22.426 0.0369632C22.1665 -0.0678591 21.873 0.0579296 21.7681 0.317365L19.7449 5.34097C19.6401 5.60041 19.7659 5.89391 20.0253 5.99873Z"
        fill={fill}
      />
      <path
        d="M11.974 25.9989C11.7145 25.8941 11.421 26.0199 11.3161 26.2793L9.29291 31.3055C9.18808 31.565 9.31386 31.8585 9.57332 31.9633C9.63622 31.9869 9.69911 32 9.762 32C9.96118 32 10.1525 31.8794 10.2311 31.6829L12.2544 26.6567C12.3592 26.3972 12.2334 26.1037 11.974 25.9989Z"
        fill={fill}
      />
      <path
        d="M0.317378 10.2311L5.34405 12.2543C5.40695 12.2779 5.46984 12.291 5.53274 12.291C5.73192 12.291 5.92323 12.1704 6.00185 11.9738C6.10669 11.7144 5.9809 11.4209 5.72144 11.316L0.694771 9.29287C0.435314 9.18804 0.1418 9.31384 0.0369687 9.57329C-0.0678626 9.83274 0.0579209 10.1263 0.317378 10.2311Z"
        fill={fill}
      />
      <path
        d="M31.6826 21.7668L26.6586 19.7436C26.3991 19.6388 26.1056 19.7646 26.0008 20.0241C25.8959 20.2835 26.0217 20.577 26.2812 20.6819L31.3052 22.705C31.3681 22.7286 31.431 22.7417 31.4939 22.7417C31.6931 22.7417 31.8844 22.6212 31.963 22.4246C32.0679 22.1652 31.9421 21.8716 31.6826 21.7668Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default StarBg;
